import axios from "axios";
import { fromJS } from "immutable";
import { FreeRoundsTypes } from "actions/types";

export function fetchFreeRoundsReject(route) {
  return (dispatch, getState) => {
    try {
      var headers = getState()
        .config.get("headers")
        .toJSON();
      var href = route.get("href");
      var url = `${href}`;
      var method = route.get("method");
    } catch (error) {
      throw error;
    }

    dispatch({
      type: FreeRoundsTypes.FETCH_FREE_ROUNDS_DETAILS,
      payload: {
        route: route,
        method: method,
        headers: headers,
        url: url,
      },
    });

    return axios({
      method,
      headers,
      url,
    }).then(({ data }) => {
      return fromJS(data);
    });
  };
}

export function fetchFreeRoundsDetails(route) {
  return (dispatch, getState) => {
    try {
      var headers = getState()
        .config.get("headers")
        .toJSON();
      var href = route.get("href");
      var url = `${href}`;
      var method = route.get("method");
    } catch (error) {
      throw error;
    }

    dispatch({
      type: FreeRoundsTypes.FETCH_FREE_ROUNDS_DETAILS,
      payload: {
        route: route,
        method: method,
        headers: headers,
        url: url,
      },
    });

    return axios({
      method,
      headers,
      url,
    }).then(({ data }) => {
      return fromJS(data);
    });
  };
}

export function setFreeRoundsDetails(payload) {
  return {
    type: FreeRoundsTypes.SET_FREE_ROUNDS_DETAILS,
    payload,
  };
}
